import { render, staticRenderFns } from "./SongsListPage.vue?vue&type=template&id=469315d6&"
import script from "./SongsListPage.vue?vue&type=script&lang=js&"
export * from "./SongsListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SongsListPage.vue"
export default component.exports